var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppNavTrips(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nav icon/2 My Trips") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 19.8718 0 19.8718 19.872 0 19.872"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav-icon/2-My-Trips",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.936,17.872 C5.56,17.872 2,14.312 2,9.936 C2,5.56 5.56,2 9.936,2 C14.312,2 17.872,5.56 17.872,9.936 C17.872,14.312 14.312,17.872 9.936,17.872 M9.936,0 C4.448,0 0,4.448 0,9.936 C0,15.423 4.448,19.872 9.936,19.872 C15.424,19.872 19.872,15.423 19.872,9.936 C19.872,4.448 15.424,0 9.936,0",
    id: "Fill-1",
    fill: "current"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.3919,11.0586 L10.8189,9.8146 L10.8189,5.0376 C10.8189,4.4856 10.3709,4.0376 9.8189,4.0376 C9.2659,4.0376 8.8189,4.4856 8.8189,5.0376 L8.8189,11.0686 L12.5209,12.8596 C12.6619,12.9266 12.8099,12.9586 12.9549,12.9586 C13.3279,12.9586 13.6839,12.7506 13.8569,12.3946 C14.0969,11.8976 13.8889,11.2986 13.3919,11.0586",
    id: "Fill-4",
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppNavTrips);
export default __webpack_public_path__ + "static/media/app_nav_trips.533ee91fd89d5c0c7a1f8d311bd9e58c.svg";
export { ForwardRef as ReactComponent };